module.exports = __webpack_public_path__ + "static/media/No_Posts.d7dc28af.png";